import { render, staticRenderFns } from "./CommentAddedNotification.vue?vue&type=template&id=4bc294f6&scoped=true"
import script from "./CommentAddedNotification.vue?vue&type=script&lang=js"
export * from "./CommentAddedNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc294f6",
  null
  
)

export default component.exports